import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ca1ea78"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "air-status" }
const _hoisted_2 = { class: "desc" }
const _hoisted_3 = { class: "breadcrumb" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-location" }, null, -1))
const _hoisted_5 = { class: "title-desc" }
const _hoisted_6 = { class: "factor-desc" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "factor-title" }, "空气质量指数（AQI）", -1))
const _hoisted_8 = { class: "updata-time" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "current-time" }, "最近更新时间", -1))
const _hoisted_10 = { class: "txt-time" }

import qs from 'qs';
import moment from 'moment';
import { useStore, } from 'vuex';
import {
  Breadcrumb, Row, Col, Menu,
} from 'ant-design-vue';
import {
  computed, watch, ref, onMounted, onUnmounted,
} from 'vue';

import forecast from './componets/forecast/index.vue';
import historyAirChart from './componets/historyAirChart/index.vue';
import Ranking from '@/pages/index/components/ranking/index.vue';
import calendar from './componets/calendar/index.vue';
import airStatusDetail from './componets/airStatusDetail/index.vue';
import airForecast from './componets/airForecast/index.vue';
import MapContainer from './componets/mapContainer/index.vue';
import allRegion from '@/configs/allRegion';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { Item, } = Breadcrumb;
const store = useStore();
// 存取所有省
const provinces = ref<any>([]);
// 存取所有省下市
const citys = ref<any>([]);
// 所选的城市regionId
const selectRegionId = ref('');
// 所选省名
const selectProvince = ref('');
// 所选城市名称
const selectCity = ref('');
// 当前站点信息
const pointInfo = computed(() => store.state.airStatus.pointInfo);
const regionId = computed(() => store.state.OLMap.regionId) || 320100000000;
const positionLoaction: any = computed(() => {
  const { location, } = store.state.OLMap;
  let temp = {};

  temp = {
    province: location?.location?.province,
    city: location?.location?.city,
  };

  return temp;
});

const ranking = ref();

// 站点数据
const airQualityMapData = computed(() => store.state.gateway.airQualityMapData);

/**
 * 获取所有的省
 * @param {any} data 当前城市配置文件
 * @returns {any} 返回所有省
 */
const getProvince = (data: any) => {
  const temp: any = [];

  data.forEach((item: any) => {
    temp.push({
      name: item.name,
      regionId: item.id,
      children: item.children,
    });
  });
  temp.sort((a: any, b: any) => a.name.localeCompare(b.name, 'zh-CN'));
  provinces.value = temp;
};

/**
 * 获取该省的城市
 * @param {any} data 当前城市
 * @returns {any} 返回该省的城市
 */
const getCityOfProvince = (data: any) => {
  const { province, city, } = data;
  const temp: any = allRegion.find((item: any) => item.name === province);
  const tempData: any = [];

  /*
   * tempData.push({
   *   regionId: temp?.id,
   *   name: '全部',
   * });
   */

  temp.children.sort((a: any, b: any) => a.name.localeCompare(b.name, 'zh-CN'));
  temp.children.forEach((item: any) => {
    tempData.push({
      regionId: item?.id,
      name: item?.name,
    });
  });

  citys.value = tempData;
};

const handlerProvinceChange = (item: any) => {
  selectProvince.value = item.name;
  selectRegionId.value = item.regionId;
  const temp: any = [];

  /*
   * temp.push({
   *   name: '全部',
   *   regionId: item.regionId,
   * });
   */

  item.children.forEach((i: any) => {
    temp.push({
      name: i.name,
      regionId: i.id,
    });
  });
  citys.value = temp;
  // 原先切换省份 城市为全部  现改为第一个城市
  selectCity.value = temp[0].name;
  store.commit('airStatus/setSelectRegionId', selectRegionId.value);
  store.commit('airStatus/setSelectCityId', temp[0].regionId);
  store.commit('airStatus/setSelectRegionName', temp[0].name);
};

const handlerCityChange = (item: any) => {
  selectRegionId.value = item.regionId;
  selectCity.value = item.name;
  store.commit('airStatus/setSelectRegionId', selectRegionId.value);
  store.commit('airStatus/setSelectCityId', selectRegionId.value);
  store.commit('airStatus/setSelectRegionName', selectCity.value);
};

const cityId = computed(() => store.state.OLMap.cityId);

watch(selectRegionId, (curSe) => {
  let params = '';

  if (curSe) {
    params = qs.stringify({
      regionId: curSe,
    });

    store.dispatch('gateway/getAirQualityMap', params);
    const mapParams = {
      indexName: 'AQI',
      type: 1,
      queryType: 0,
    };

    store.dispatch('gateway/getHistoryData', mapParams);
    store.dispatch('OLMap/getSelectCityExtentData', params);
  } else {
    store.commit('OLMap/setStateItem', {
      value: {},
      type: 'selectCityExtent',
    });
  }
});

onMounted(() => {
  if (regionId.value) {
    const params = qs.stringify({ regionId: regionId.value, });

    store.dispatch('gateway/getAirQualityMap', params);
    const mapParams = {
      indexName: 'AQI',
      type: 1,
      queryType: 0,
    };

    store.dispatch('gateway/getHistoryData', mapParams);
    getProvince(allRegion);
    getCityOfProvince(positionLoaction.value);
  }

  if (cityId.value) {
    const paramsExtent = qs.stringify({ regionId: cityId.value, });

    store.dispatch('OLMap/getExtentData', paramsExtent);
  }
  store.commit('OLMap/setStateItem', { value: {}, type: 'selectCityExtent', });
  store.commit('airStatus/setSelectRegionId', { value: '', type: 'selectRegionId', });
});

onUnmounted(() => {
  store.commit('airStatus/setSelectRegionId', '');
  store.commit('airStatus/setSelectCityId', '');
  store.commit('airStatus/setSelectRegionName', '');
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_unref(Breadcrumb), null, {
          default: _withCtx(() => [
            _createVNode(_unref(Item), null, {
              overlay: _withCtx(() => [
                _createVNode(_unref(Menu), null, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(provinces.value, (item) => {
                      return (_openBlock(), _createBlock(_unref(Menu).Item, {
                        key: item.name,
                        onClick: ($event: any) => (handlerProvinceChange(item))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(`${selectProvince.value || _unref(positionLoaction).province}`), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Item), null, {
              overlay: _withCtx(() => [
                _createVNode(_unref(Menu), null, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(citys.value, (item) => {
                      return (_openBlock(), _createBlock(_unref(Menu).Item, {
                        key: item.name,
                        onClick: ($event: any) => (handlerCityChange(item))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(`${!selectCity.value  ? selectProvince.value || _unref(positionLoaction).city : selectCity.value}`) + " ", 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_5, _toDisplayString(`${_unref(pointInfo).pointName ? _unref(pointInfo).pointName : selectCity.value === '全部' || selectCity.value === '' ? selectProvince.value || _unref(positionLoaction).city : selectCity.value}`) + "的空气质量 ", 1),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(moment)(_unref(airQualityMapData)[0]?.reportTime, 'YYYYMMDDHHmm').format('YYYY年M月D日 HH:mm')), 1)
        ])
      ])
    ]),
    _createVNode(MapContainer),
    _createVNode(_unref(Row), null, {
      default: _withCtx(() => [
        _createVNode(_unref(Col), {
          lg: 7,
          xs: 24
        }, {
          default: _withCtx(() => [
            _createVNode(forecast),
            _createVNode(Ranking, {
              ref_key: "ranking",
              ref: ranking,
              listLength: 20,
              type: 'airStauts'
            }, null, 512)
          ]),
          _: 1
        }),
        _createVNode(_unref(Col), {
          lg: 17,
          xs: 24
        }, {
          default: _withCtx(() => [
            _createVNode(airStatusDetail),
            _createVNode(airForecast),
            _createVNode(historyAirChart),
            _createVNode(calendar)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})